<template>
<div class="">
  <div class="bodyer_right" :style="bodyerstyle">
    <div class="titleview">
      <titleview title="实时捐助" icon="fengche" color=""></titleview>
    </div>
    <div class="bodyer_right_box oftbox">
      <div class="li" v-for="(item, index) in list" :key="index">
        <div class="headerimg"></div>
        <div class="deahLine">
          <div class="name">
            <!--  "在" +
                item.activityId_dictText + 项目-->
		    <span>{{item.donationUserId.substring(0,8)}}</span>
			<span v-if="item.donationUserId.length > 6">...</span>
            {{"捐助" + item.money + "元" }}
            <span></span>
          </div>
          <div class="date">{{ item.donationDate }}</div>
        </div>
      </div>
    </div>
  </div>
 </div> 
</template>

<script>
export default {
  props: {
    bodyerstyle: {
      type: String
    }
  },
  data() {
    return {
      curr: 0,
      list: []
    };
  },
  methods: {
    init() {
      var that = this;
      this.httpGet("web/donation/thpDonationRecord/list", {
        pageNo: 1,
        pageSize: 10
      }).then(res => {
        console.log(res.result.records, 11111111111);
        that.list = res.result.records;
      });
    }
  },
  mounted() {},
  created() {
    this.init();
  }
};
</script>

<style scoped="scoped" lang="scss">
.titleview {
  height: 38px;
  background: #e41e15;
	
  width: 100%;
}
.bodyer_right {
  width: 405px;
  height: 406px;
  padding: 0;
  margin: 0;
  background: #ffffff;
  overflow: hidden;
}
.bodyer_right_box {
  border: 1px solid #ededed;
  height: 485px;
  .title {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #99a0ac;
    line-height: 24px;
    margin: 13px auto 24px 19px;
    overflow: hidden;
    .icon {
      width: 18px;
      height: 24px;
      background: url(../assets/wx.png) no-repeat center/100% 100%;
      float: left;
    }
    .date {
      float: left;
      margin-left: 10px;
    }
  }
  .li {
    overflow: hidden;
    color: #666666;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    position: relative;
    .headerimg {
      width: 12px;
      height: 12px;
      background: #ffffff;
      float: left;
      margin: 17px 0 0 20px;
      background: url(../assets/lingxing.png) no-repeat center / 100% 100%;
    }
    .deahLine {
      width: 327px;
      height: 46px;
      line-height: 46px;
      float: left;
      margin-left: 8px;
      border-bottom: 1px dotted #ededed;
      overflow: hidden;
    }
    .name {
      font-size: 14px;
      float: left;
      span {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .date {
	  font-size: 14px;
      float: right;
      margin-right: 2px;
    }
  }
  .li:hover {
    // color: #e41e15;
  }
}
</style>
